import React from 'react';
import '../CSS/Healthcare.css';

const Healthcare: React.FC = () => {
  return (
    <div className="healthcare-page">
      <div className="healthcare_banner">
        <div className="healthcare-banner-overlay"></div>
        <div className="banner-content">
          <h1 className="banner-title">Healthcare</h1>
        </div>
      </div>
      
      <div className="healthcare_mantra">
        <p>Leverage our custom AI agents and integration of AI solutions with healthcare software to improve patient outcomes, provide remote care and enhance healthcare operation workflows.</p>
      </div>

      <div className="healthcare_crm_solutions">
        <div className="crm-content">
          <h2 className="crm-title">Intelligent CRM Solutions</h2>
          <div className="crm-description">
            <p>We help healthcare providers harness the power of AI and Big Data to understand their data and utilize it for decision making. With data analytics, healthcare providers can make quick decisions to improve patient care and medical workflow.</p>
            <p>Agentic AI Solutions can be built and customized for hospitals, clinics, dental, physical therapy, homecare providers, and healthcare insurance.</p>
          </div>
        </div>
      </div>

      {/* Healthcare Pairings Section - Desktop */}
      <div className="healthcare_pairings desktop-healthcare-pairings">
        <div className="healthcare_pairing-content">
          {/* First Pairing - Streamlining Administrative Operations */}
          <div className="healthcare_image_right">
            <div className="healthcare-section-image">
              <img src="/Assets/Healthcare/streamlining-administrative-operations-section-image.png" alt="Streamlining Administrative Operations" />
            </div>
            <div className="healthcare_section_text">
              <h2 className="healthcare_section_title">Streamlining Administrative Operations</h2>
              <div className="section-description">
                <div className="description-item">
                  <img src="/Assets/Icons/green-tick-icon.svg" alt="Checkmark" className="checkmark-icon" />
                  <span><strong>Scheduling and Matching:</strong> AI algorithms analyze caregiver profiles and patient needs to optimize scheduling, ensure compatibility, and enhance satisfaction for both parties.</span>
                </div>
                <div className="description-item">
                  <img src="/Assets/Icons/green-tick-icon.svg" alt="Checkmark" className="checkmark-icon" />
                  <span><strong>Documentation Assistance:</strong> AI-powered medical scribe applications transcribe and organize clinical notes, thereby reducing administrative burdens on caregivers.</span>
                </div>
              </div>
            </div>
           
          </div>

          {/* Second Pairing - Personalized and Proactive Personal Care */}
          <div className="healthcare_image_left">
            <div className="healthcare-section-image">
              <img src="/Assets/Healthcare/personal-care-section-image.png" alt="Personalized and Proactive Personal Care" />
            </div>
            <div className="healthcare_section_text">
              <h2 className="healthcare_section_title">Personalized and Proactive Personal Care</h2>
              <div className="section-description">
                <div className="description-item">
                  <img src="/Assets/Icons/green-tick-icon.svg" alt="Checkmark" className="checkmark-icon" />
                  <span><strong>Personalized Care Plans:</strong> AI analyzes patient data to develop tailored care plans, improving adherence and outcomes.</span>
                </div>
                <div className="description-item">
                  <img src="/Assets/Icons/green-tick-icon.svg" alt="Checkmark" className="checkmark-icon" />
                  <span><strong>Remote Monitoring:</strong> AI-enabled devices monitor patients' health in real-time, detecting anomalies and alerting caregivers to potential issues.</span>
                </div>
              </div>
            </div>
          </div>

          {/* Third Pairing - Alleviating Staffing Challenges */}
          <div className="healthcare_image_right">
          <div className="healthcare-section-image">
              <img src="/Assets/Healthcare/staffing-challanges-section-image.png" alt="Alleviating Staffing Challenges" />
            </div>
            <div className="healthcare_section_text">
              <h2 className="healthcare_section_title">Alleviating Staffing Challenges</h2>
              <div className="section-description">
                <div className="description-item">
                  <img src="/Assets/Icons/green-tick-icon.svg" alt="Checkmark" className="checkmark-icon" />
                  <span><strong>Task Automation:</strong> Automating routine tasks reduces the workload on caregivers, allowing them to focus on direct patient care.</span>
                </div>
                <div className="description-item">
                  <img src="/Assets/Icons/green-tick-icon.svg" alt="Checkmark" className="checkmark-icon" />
                  <span><strong>Recruitment and Training:</strong> AI assists in identifying qualified candidates and provides personalized training programs to enhance caregiver skills.</span>
                </div>
              </div>
            </div>
          </div>

          {/* Fourth Pairing - Improving Operational Efficiency */}
          <div className="healthcare_image_left">
            <div className="healthcare-section-image">
              <img src="/Assets/Healthcare/operational-efficiency-section-image.png" alt="Improving Operational Efficiency" />
            </div>
            <div className="healthcare_section_text">
              <h2 className="healthcare_section_title">Improving Operational Efficiency</h2>
              <div className="section-description">
                <div className="description-item">
                  <img src="/Assets/Icons/green-tick-icon.svg" alt="Checkmark" className="checkmark-icon" />
                  <span><strong>Predictive Analytics:</strong> Analyzing data to forecast patient needs and optimize resource allocation, leading to cost savings and improved care delivery.</span>
                </div>
                <div className="description-item">
                  <img src="/Assets/Icons/green-tick-icon.svg" alt="Checkmark" className="checkmark-icon" />
                  <span><strong>Quality Assurance:</strong> Monitoring caregiver performance and patient satisfaction to ensure high standards of care.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Healthcare Pairings Section - Mobile (480px) */}
      <div className="healthcare_pairings mobile-healthcare-pairings">
        <div className="healthcare_pairing-content">
          {/* First Pairing - Streamlining Administrative Operations */}
          <div className="mobile-healthcare-section">
            <div className="mobile-healthcare-text">
              <h2 className="mobile-healthcare-title">Streamlining Administrative Operations</h2>
              <div className="mobile-section-description">
                <div className="mobile-description-item">
                  <img src="/Assets/Icons/green-tick-icon.svg" alt="Checkmark" className="mobile-checkmark-icon" />
                  <span><strong>Scheduling and Matching:</strong> AI algorithms analyze caregiver profiles and patient needs to optimize scheduling, ensure compatibility, and enhance satisfaction for both parties.</span>
                </div>
                <div className="mobile-description-item">
                  <img src="/Assets/Icons/green-tick-icon.svg" alt="Checkmark" className="mobile-checkmark-icon" />
                  <span><strong>Documentation Assistance:</strong> AI-powered medical scribe applications transcribe and organize clinical notes, thereby reducing administrative burdens on caregivers.</span>
                </div>
              </div>
            </div>
            <div className="mobile-healthcare-image">
              <img src="/Assets/Healthcare/streamlining-administrative-operations-section-image.png" alt="Streamlining Administrative Operations" />
            </div>
          </div>

          {/* Second Pairing - Personalized and Proactive Personal Care */}
          <div className="mobile-healthcare-section">
            <div className="mobile-healthcare-text">
              <h2 className="mobile-healthcare-title">Personalized and Proactive Personal Care</h2>
              <div className="mobile-section-description">
                <div className="mobile-description-item">
                  <img src="/Assets/Icons/green-tick-icon.svg" alt="Checkmark" className="mobile-checkmark-icon" />
                  <span><strong>Personalized Care Plans:</strong> AI analyzes patient data to develop tailored care plans, improving adherence and outcomes.</span>
                </div>
                <div className="mobile-description-item">
                  <img src="/Assets/Icons/green-tick-icon.svg" alt="Checkmark" className="mobile-checkmark-icon" />
                  <span><strong>Remote Monitoring:</strong> AI-enabled devices monitor patients' health in real-time, detecting anomalies and alerting caregivers to potential issues.</span>
                </div>
              </div>
            </div>
            <div className="mobile-healthcare-image">
              <img src="/Assets/Healthcare/personal-care-section-image.png" alt="Personalized and Proactive Personal Care" />
            </div>
          </div>

          {/* Third Pairing - Alleviating Staffing Challenges */}
          <div className="mobile-healthcare-section">
            <div className="mobile-healthcare-text">
              <h2 className="mobile-healthcare-title">Alleviating Staffing Challenges</h2>
              <div className="mobile-section-description">
                <div className="mobile-description-item">
                  <img src="/Assets/Icons/green-tick-icon.svg" alt="Checkmark" className="mobile-checkmark-icon" />
                  <span><strong>Task Automation:</strong> Automating routine tasks reduces the workload on caregivers, allowing them to focus on direct patient care.</span>
                </div>
                <div className="mobile-description-item">
                  <img src="/Assets/Icons/green-tick-icon.svg" alt="Checkmark" className="mobile-checkmark-icon" />
                  <span><strong>Recruitment and Training:</strong> AI assists in identifying qualified candidates and provides personalized training programs to enhance caregiver skills.</span>
                </div>
              </div>
            </div>
            <div className="mobile-healthcare-image">
              <img src="/Assets/Healthcare/staffing-challanges-section-image.png" alt="Alleviating Staffing Challenges" />
            </div>
          </div>

          {/* Fourth Pairing - Improving Operational Efficiency */}
          <div className="mobile-healthcare-section">
            <div className="mobile-healthcare-text">
              <h2 className="mobile-healthcare-title">Improving Operational Efficiency</h2>
              <div className="mobile-section-description">
                <div className="mobile-description-item">
                  <img src="/Assets/Icons/green-tick-icon.svg" alt="Checkmark" className="mobile-checkmark-icon" />
                  <span><strong>Predictive Analytics:</strong> Analyzing data to forecast patient needs and optimize resource allocation, leading to cost savings and improved care delivery.</span>
                </div>
                <div className="mobile-description-item">
                  <img src="/Assets/Icons/green-tick-icon.svg" alt="Checkmark" className="mobile-checkmark-icon" />
                  <span><strong>Quality Assurance:</strong> Monitoring caregiver performance and patient satisfaction to ensure high standards of care.</span>
                </div>
              </div>
            </div>
            <div className="mobile-healthcare-image">
              <img src="/Assets/Healthcare/operational-efficiency-section-image.png" alt="Improving Operational Efficiency" />
            </div>
          </div>
        </div>
      </div>

      <div className="healthcare_engagement_models">
        <div className="engagement-models-content">
          <h2 className="engagement-models-title">Our Engagement Models</h2>
          <div className="engagement-models-grid">
            <div className="engagement-model-card">
              <div className="model-icon">
                <img src="/Assets/Icons/dedicated-dev-team-icon.svg" alt="Dedicated Development Team" />
              </div>
              <h3 className="model-title">Dedicated Development Team</h3>
              <p className="model-description">Our developers leverage cutting-edge cognitive technologies to deliver high-quality services and tailored solutions to our clients.</p>
            </div>
            
            <div className="engagement-model-card">
              <div className="model-icon">
                <img src="/Assets/Icons/team-extension-icon.svg" alt="Team Extension" />
              </div>
              <h3 className="model-title">Team Extension</h3>
              <p className="model-description">Our team extension model is designed to assist clients seeking to expand their teams with the precise expertise needed for their projects.</p>
            </div>
            
            <div className="engagement-model-card">
              <div className="model-icon">
                <img src="/Assets/Icons/project-based-model-icon.svg" alt="Project-based Model" />
              </div>
              <h3 className="model-title">Project-based Model</h3>
              <p className="model-description">Our project-oriented approach, supported by our team of software development specialists, is dedicated to fostering client collaboration, and achieving specific project objectives.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Healthcare; 